import type { TermsAcceptanceItem } from "../../domain/entities";
import type { TermsRepositoryPort } from "../ports/terms.repository.port";

export function acceptTermsUseCase(
  repository: TermsRepositoryPort,
  items: TermsAcceptanceItem[],
) {
  if (!items || items.length === 0) {
    throw new Error("Pelo menos um termo deve ser aceito.");
  }
  return repository.accept(items);
}
